import { IconHeading } from '@tabler/icons';
import { useCurrentEditor } from '@tiptap/react';
import { Tooltip } from '@mantine/core';
import { FC } from 'react';
import ActionIconWithoutFocus from '../../../../Atoms/ActionIconWithoutFocus';

const ToolbarHeadingIcon: FC<{ includeTooltip?: boolean }> = ({ includeTooltip = true }) => {
  const { editor } = useCurrentEditor();
  if (!editor) {
    return null;
  }
  const isActive = editor.isActive('textStyle', { fontSize: '18pt' });

  const toggle = () => {
    if (isActive) {
      editor.chain().focus().unsetFontSize().run();
    } else {
      editor.chain().focus().setFontSize('18pt').run();
    }
  };

  return (
    <Tooltip withArrow disabled={!includeTooltip} openDelay={300} transition="slide-up" label="Überschriften">
      <div>
        <ActionIconWithoutFocus variant={isActive ? 'filled' : 'subtle'} onClick={toggle}>
          <IconHeading size={20} />
        </ActionIconWithoutFocus>
      </div>
    </Tooltip>
  );
};

export default ToolbarHeadingIcon;
